import angular from 'angular';

import BrowserServ from './browser';
import analyticsLoader from 'analytics.js-loader';

import VersionConst from '../constants/version';

class AnalyticsServ {
  constructor($window, Browser, VersionConst) {
    this.analytics = analyticsLoader({
      writeKey: $window.conf.segment,
      skipPageCall: true
    });

    this.olark = $window.olark;
    this.browser = Browser;
    this.analytics.ready(() => {
      Rollbar && Rollbar.configure({
        checkIgnore: this.ignoreRemoteUncaught,
        payload: {
          client: {
            javascript: {
              source_map_enabled: true,
              /* provided by webpack define plugin*/
              code_version: VERSION,
              guess_uncaught_frames: true
            }
          }
        }
      });
    });
    this.analytics.identify({
      Version: VersionConst
    });

  }

  // Stricter tracking events in the future, methods passed through for now
  page(path, data = {}) {
    let page = Object.assign({ path }, data)
    this.analytics.page(path, page);
  }

  clicked(eventName, data = {}) {
    this.analytics.track('Clicked ' + eventName, data);
  }

  blurredField(fieldName) {
    this.analytics.track(`${fieldName} Field Blurred`);
  }

  focusedField(fieldName) {
    this.analytics.track(`${fieldName} Field Focused`);
  }

  setUser(user) {
    this.analytics.identify(user.id, user);
  }
  signedUp(data, invited) {
    var user = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      currentAccountId: data.currentAccountId,
      id: data.id,
      'Signed Up': new Date(),
      'Browser Version': `${this.browser.name} ${this.browser.version}`,
      'Invited': invited || false,
      'Lexicon': data.lexicon || 'legal',
      'Paid': null
    };

    this.analytics.alias(user.id);
    this.setUser(user);
    this.analytics.track('Signed Up');
  }
  signedIn(user) {
    user['Browser Version'] = `${this.browser.name} ${this.browser.version}`;
    this.setUser(user);
    this.analytics.track('Signed In');
  }
  signedOut() {
    this.analytics.track('Signed Out');
    this.analytics.reset();
  }
  userVerified(user) {
    user['Verified On'] = new Date();
    this.setUser(user);
    this.analytics.track('User Verified');
  }
  userMfaEnabled(user) {
    user['MFA'] = true;
    user['MFA Enabled'] = new Date();
    this.setUser(user);
    this.analytics.track('User Enabled MFA');
  }
  userMfaDisabled(user) {
    user['MFA'] = false;
    user['MFA Disabled'] = new Date();
    this.setUser(user);
    this.analytics.track('User Disabled MFA');
  }

  added(attr, data = {}) {
    // Track event, increment <Attr>s Added prop, set Attr Last Added
    var user = {};
    user[`Last ${attr} Added`] = new Date();
    this.analytics.identify(user);

    this.analytics.track(`${attr} Added`, data);
  }
  updated(attr, data = {}) {
    this.analytics.track(`${attr} Updated`, data);
  }
  removed(attr) {
    this.analytics.track(`${attr} Removed`);
  }

  reset() {
    this.analytics.reset();
  }
  setFirstSeen() {
    this.analytics.ready(() => {
      mixpanel && mixpanel.people.set_once({
        'First Seen': new Date()
      })
    });

  }
  setChatVisibility(show) {
    this.analytics.ready(() => {
      olark && olark(show ? 'api.box.show' : 'api.box.hide');
    });
  }
  ignoreRemoteUncaught(isUncaught, args, payload) {
    // adapted from https://gist.github.com/coryvirok/2bd77c35db1ab758afe5
    try {
      var filename = payload.data.body.trace.frames[0].filename;
      if (isUncaught && !/^https?:\/\/(staging\.)?getfactbox\.com/.test(
          filename)) {
        return true;
      }
    } catch (e) {}
    return false;
  }
}
AnalyticsServ.$inject = ['$window', 'Browser', 'VersionConst'];

export default angular.module('services.analytics', [BrowserServ, VersionConst])
  .service('AnalyticsServ', AnalyticsServ)
  .name;



// WEBPACK FOOTER //
// ./project/services/analytics.js